import { Component } from 'react';
import Plan from './components/Plan';
import LinkedAccounts from './components/LinkedAccounts';
import Domains from './components/Domains';
import Users from './components/Users';
import AdditionalEmailsSettings from './components/AdditionalEmailsSettings';
import Plan_Products from './components/Plan_Products';

class Settings extends Component {
    constructor() {
        super();
        this.is_not_viewer = window.is_not_viewer;
    }

    render() {
        return (
            <>
                <Plan_Products
                    is_deactivated={this.props.is_deactivated}
                    customer_id={this.props.customer_id}
                    cancel_at_period_end={this.props.cancel_at_period_end}
                    cancel_in={this.props.cancel_in}
                />
                <LinkedAccounts {...this.props} />
                <Domains {...this.props} />
                <Users isViewer={!this.is_not_viewer} {...this.props} />
                {this.is_not_viewer && (
                    <>
                        <AdditionalEmailsSettings
                            report_permission_all_authors={this.props.report_permission_all_authors}
                            report_permission_individual_authors={
                                this.props.report_permission_individual_authors
                            }
                        />
                    </>
                )}
            </>
        );
    }
}

export default Settings;
